export function blobToFile(blob: Blob, name: string): File {
  blob['lastModifiedDate'] = new Date();
  blob['lastModified'] = Date.now();
  blob['name'] = name;

  return blob as File;
}
